import React from "react";
import { Card, Col, Container, Row } from "react-bootstrap";

const Blog1 = () => {
  return (
    <div className="blog">
      <div className="row">
        <div className="col-md-9  article-area">
          <h2
            style={{ marginTop: "85px" }}
            className="mb-5 text-center project-title"
          >
            CSS Flexbox Layout
          </h2>
          <div style={{ justifyContent: "center" }} className="d-flex">
            <img
              className="img-fluid"
              src="https://i.ibb.co/H79dpJc/5491136649494528.jpg"
              alt="css-flexbox"
            />
          </div>
          <br />
          <article>
            <p>
              <b>Flexbox:</b> In CSS flexbox is used to arranging items in row
              or columns. Before flexbox developer used to design layout with
              float and positioning. And it was very hard to arrange. But using
              flexbox it became very easy and flexible.
            </p>
            <br />
            <p>
              To use flexbox layout we just declare the parents element display:
              flex;
            </p>
            <p>
              <b> What you will learn form this blog post?</b>
            </p>
            <ol>
              <li>How to use flexbox layout.</li>
              <li>You will learn about all the flexbox properties.</li>
              <li>You will learn why and when we should use it.</li>
              <li>You also learn all the best practice of flex box.</li>
            </ol>
            <br />
            <p>
              <b>Introducing flexbox with a simple example: </b>
            </p>
            <br />
            <p>
              In this picture below, the layout is a simple paragraph inside a
              &lt;div&gt; tag inside a parent &lt;/div&gt;. And I use some
              magin, padding and border to this.
            </p>
            <div style={{ justifyContent: "center" }} className="d-flex">
              <img
                className="img-fluid"
                src="https://i.ibb.co/nByCX67/Screenshot-38.jpg"
                alt=""
              />
            </div>

            <br />
            <p>
              <b>After using CSS flexbox:</b>
            </p>
            <br />
            <p>
              If we declare the parent &lt;div&gt; display: flex;Then this
              simple layout will change into a nice flexbox layout and the row
              align div element will align in column inside a row.
            </p>
            <br />
            <div style={{ justifyContent: "center" }} className="d-flex">
              <img
                className="img-fluid"
                src="https://i.ibb.co/wQv7MLy/Screenshot-37.jpg"
                alt=""
              />
            </div>
            <br />
            <p>
              <b>Column or Row?</b>
            </p>
            <p>
              The flexbox layout is default align in a row and divide in column.
              But sometimes we need to align the flexbox item in a column then
              you have to use the flex-direction flex-direction: column;
            </p>
            <br />
            <p>
              <b>Wrapping: flex-wrap</b>
            </p>
            <p>
              There is one issue arise when the parents have so many child
              items. In this case the child item sits beside and became a masy
              design. Like the page below.
            </p>
            <div style={{ justifyContent: "center" }} className="d-flex">
              <img
                className="img-fluid"
                src="https://i.ibb.co/Njytsj1/Screenshot-40.jpg"
                alt=""
              />
            </div>
            <p>
              But there is a solution in flexbos layout. There is a property
              called flex-wrap in flexbox. When we declare the child items
              flex-wrap: wrap; will break depending on the device width. But we
              need to declare the width of the child item. For this design I use
              flex: 200px;
            </p>
            <p>
              The best thing in the flex-wrap property is it align the child div
              very well and it also adjust the height of the child div
            </p>
            <div style={{ justifyContent: "center" }} className="d-flex">
              <img
                className="img-fluid"
                src="https://i.ibb.co/ZYmjTnF/Screenshot-39.jpg"
                alt=""
              />
            </div>
            <br />
            <p>
              <b>Horizontal and vertical alignment:</b>
            </p>
            <p>
              Horizontral and vertical alignment became very easy with flexbox
              alignment. We can align items vertically and horizoontally very
              easily with css flexbox layout. If we want to align items in
              vertically then we should use align-items: center; And If we want
              to align items is horizontally align then we should use
              justify-content: center;
            </p>
          </article>
        </div>
        {/*--------------- Adds section -------------- */}
        <div className="col-md-3">
          <img
            style={{ marginTop: "70px" }}
            src="https://i.ibb.co/HXcfLN6/9656093656252652900.gif"
            alt=""
            className="img-fluid"
          />
        </div>
      </div>
    </div>
  );
};

export default Blog1;
